import React from "react";
import { connect } from "react-redux";
import SRNoValidationComponent from "../../components/assessment/SRNoValidationComponent";
import { SRNO_VALIDATE } from "../../constants/apiContants";
import { sendRequest } from "../../util/httpRequest";


const SrNoValidationContainer = props => {
    return <SRNoValidationComponent {...props}
    />;
};

const mapStateToProps = state => {
    let props = {};
    return props;
};

const mapDispatchToProps = (dispatch, props) => ({

    // , assessmentId, callback, errorCallback




    validate: function (srNumber, callback, errorCallback) {
        let assessmentId = "5f4e2710d5724e579ecdc187"
        // Encrypt
        let url = SRNO_VALIDATE + "?srnNo=" + srNumber + "&assessmentId=" + assessmentId
        let data = ''
        console.log("result", url)
        // calllback(assessmentId)
        sendRequest(url, "POST", "", "", (res, err) => {
            console.log("RESULTS", res, res.status)

            if (res.data.success === true) {
                console.log("result", res)
                // data = res
                callback(res)
                console.log("data", data)
            } else {
                errorCallback(res)
                console.log("error", err)
            }

        })
    },


});
/********************* END ********************/

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SrNoValidationContainer);
